<template>
  <NodeViewWrapper
    as="li"
    class="relative list-item h-full outline-none"
    :class="{ 'shadow-header py-2 -ml-6 pl-10': dragged && !node.attrs.isEvent }"
    :draggable="isMobile"
    data-drag-handle
    @touchstart="disableContentSelecting"
    @touchmove="onTouchMove"
    @touchend="onTouchEnd"
    @touchcancel="onTouchEnd"
  >
    <i
      v-if="!node.attrs.isEvent"
      class="icon-drag_indicator drag-icon pr-4 absolute"
      data-drag-handle
      :style="alignDragIcon"
      @mousedown="hideBubbleMenu"
      @mouseup="onDragEnd"
    />

    <div
      class="w-16 h-full absolute flex items-center justify-center"
      :draggable="isMobile"
      data-drag-handle
    >
      <span
        class="w-8 h-8 m-auto rounded-full bg-main-color absolute"
        :class="{ 'left-10': dragged && !node.attrs.isEvent }"
        :style="alignText"
      />
    </div>

    <NodeViewContent
      ref="content"
      as="div"
      :draggable="isMobile && isContentDisabled"
      class="list-item-content w-full outline-none"
      :contenteditable="!(isMobile && isContentDisabled) && isEditable"
      :class="[isMobile && isContentDisabled ? 'pointer-events-none' : '', node.attrs.isEvent ? 'pl-27' : '-ml-30 pl-57']"
    />
  </NodeViewWrapper>
</template>

<script>
import draggableMixin from '@/mixins/draggable'
import { mapGetters, mapState } from 'vuex'
import { NodeViewContent, NodeViewWrapper } from '@tiptap/vue-3'
import { unselectText } from '@/core/helper-functions'
import { alignmentDragIcon, alignmentList } from '@/core/alignments'

export default {

  components: {
    NodeViewContent,
    NodeViewWrapper
  },

  mixins: [draggableMixin],

  data () {
    return {
      dragged: false,
      timer: null,
      isContentDisabled: false
    }
  },

  computed: {
    ...mapGetters(['isMobile']),

    ...mapState({
      settings: state => state.settings.settings
    }),

    alignText () {
      if (this.node.attrs.isEvent || this.$route.name === 'Share') {
        return 'top: 9px'
      }

      return alignmentList[this.settings.fontSize + this.settings.lineHeight]
    },

    alignDragIcon () {
      if (this.node.attrs.isEvent || this.$route.name === 'Share') {
        return 'top: 0'
      }

      return alignmentDragIcon[this.settings.fontSize + this.settings.lineHeight]
    },

    isEditable () {
      return this.editor.isEditable
    }
  },

  methods: {
    disableContentSelecting () {
      if (this.isMobile) {
        if (this.editor.isFocused) {
          this.isContentDisabled = false
        } else {
          this.isContentDisabled = true
          this.timer = setTimeout(() => {
            this.dragged = true
          }, 500)
        }

        this.hideBubbleMenu()
      }
    },
    onTouchMove () {
      unselectText()

      clearTimeout(this.timer)
      this.dragged = false
    },

    onTouchEnd () {
      clearTimeout(this.timer)
      this.dragged = false
      this.onDragEnd()
      this.isContentDisabled = false
    },

    hideBubbleMenu () {
      const drag = () => {
        unselectText()
        const el = document.getElementById('menububble')
        if (el.classList.contains('is-active')) el.classList.remove('is-active')

        // add grab hand cursor (from mixin)
        this.onStart()
        this.editor.chain().blur()
      }

      const dragstart = () => {
        unselectText()
        // delete grabbing cursor from dom on drag start (from mixin)
        this.onDragEnd()
        // add grab hand cursor on mouse down / touch start events (from mixin)
        this.onStart()
      }

      const drop = () => {
        clearTimeout(this.timer)
        this.dragged = false
        unselectText()

        this.editor.chain().blur().run()

        document.removeEventListener('drag', drag)
        document.removeEventListener('drop', drop)
        document.removeEventListener('dragstart', dragstart)

        // remove grab hand cursor(from mixin)
        this.onDragEnd()
      }

      document.addEventListener('drop', drop)
      document.addEventListener('drag', drag)
      document.addEventListener('dragstart', dragstart)
    }
  }
}
</script>

<style lang="scss" scoped>
.drag {
  top: 50%;
  transform: translateY(-50%);
}
</style>
